export default class FetchStatus {
  constructor(private readonly _value: boolean = false) {
  }

  public isFetching(): boolean {
    return this._value ? this._value : false;
  }
}